//TODO: REMOVE THIS FILE WHEN ADD AUCTIONS
//TO REWARDS TABS ON PARTNER PAGE

import { type FetchFanShopProductVariantsData, minutesToMs } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { validationRule } from '../../util';
import { fanShopApi } from '../api';

export const UseProductsSingleQueryKeyBuilder = (partnerIds: Array<string> = [], isTestValidId?: boolean | undefined) =>
	['fanshopProductUpdateFromWS', 'fanShop', 'products', ...partnerIds, isTestValidId] as const;

/**
 * Returns all products - no pagination
 */

export const useProductsSingleQueries = (
	partnerIds: Array<string>,
	options?: Omit<
		UseQueryOptions<FetchFanShopProductVariantsData, Error, FetchFanShopProductVariantsData>,
		'queryFn' | 'queryKey'
	>
) => {
	const isTestValidId: boolean | undefined = partnerIds && partnerIds?.every(validationRule);

	return useQuery({
		...options,
		enabled: !!partnerIds?.length,
		queryFn: async () =>
			(await fanShopApi).fetchFanShopProductVariants({
				'details[]': [
					'productTranslations',
					'productCategoryTranslations',
					'productVariantTranslations',
					'productImages',
					'productTierLevelTranslations',
					'tagTranslations',
					'productTypeTranslations',
					'countryTranslations',
					'productVariantImages'
				],
				'productRedeemTypes[]': ['regular', 'reverseAuction'],
				...(isTestValidId && { 'partnerIds[]': partnerIds })
			}),
		queryKey: UseProductsSingleQueryKeyBuilder(partnerIds, isTestValidId),
		select: data => data.data || [],
		staleTime: minutesToMs(5)
	});
};
